import { Box, Button } from "@mui/material";
import { useEffect, useState } from "react";
import useArrayObject from "../../hooks/useArrayObject";
import { CompanyTitledPage } from "../TitledPage";
import DetailTable from "./DetailTable";
import Header from "./Header";
import useChainStoreAPI from "./useChainStoreAPI";
import useInputObject from "../../hooks/useInputObject";

function handleKeyDown(event) {
  if (event.key === "Insert" && event.location === 0) {
    event.preventDefault();
    document.getElementById("upsertChainStoreButton").click();
  }
}

const ChainStoreEntry = () => {
  const {
    header,
    details: detailsAPI,
    upsert,
    initialDetail,
  } = useChainStoreAPI();

  const details = useArrayObject([]);

  const modalState = useInputObject();

  // 更新をかけてよいかどうかを保持するstate
  const [isReadyToUpdate, setIsReadyToUpdate] = useState(false);

  useEffect(() => {
    details.setValue(detailsAPI.Value);
    // console.log("DetailAPI Value : ", detailsAPI.Value);
  }, [detailsAPI.Value]);

  useEffect(() => {
    if (isReadyToUpdate) {
      const data = { groupInfo: header.Value, listDetail: details.Value };
      (async () => {
        await upsert(data);
        focusToBuyerNo();
        setIsReadyToUpdate(false);
      })();
    }
  }, [isReadyToUpdate]);

  async function handleUpsert() {
    console.log("click handle upsert");
    document.getElementById(document.activeElement.id).blur();
    setIsReadyToUpdate(true);
  }

  function focusToBuyerNo() {
    document.getElementById("header-1").focus();
  }

  function addDetail() {
    const newDetail = {
      ...initialDetail,
      slipDetailId: getNextIdDetails(),
    };
    details.push(newDetail);
  }

  function getNextIdDetails() {
    const maxSlipDetailId = Math.max(
      ...details.Value.map((detail) => detail.slipDetailId)
    );
    return maxSlipDetailId + 1;
  }

  return (
    <>
      <CompanyTitledPage title="チェーンストア原票エントリ">
        <Box onKeyDown={handleKeyDown}>
          <Header header={header} modalState={modalState} />
          <DetailTable
            details={details}
            detailsAPI={detailsAPI}
            addDetail={addDetail}
            header={header}
            modalState={modalState}
          />
          <Button
            variant="outlined"
            onClick={handleUpsert}
            id="upsertChainStoreButton"
          >
            登録
          </Button>
        </Box>
      </CompanyTitledPage>
    </>
  );
};

export default ChainStoreEntry;
